import test from 'models/test.model';
import auth from 'models/auth.model';
import serviceRequest from 'models/service_request';
import targetView from 'models/target_view.model';

export const Models = {
  test,
  auth,
  serviceRequest,
  targetView
}

export default Models